<div mat-dialog-content>
  <app-notifications-list
    (closeModal)="onClose($event)"
    [maxNotificationsShown]="maxNotificationsShown"
  ></app-notifications-list>
</div>
